<template>
  <div class="px-30 py-10" style="height: 610px" ref="filesTab">
    <div class="row gx-15 mb-10 gy-0" v-if="!loadingState">
      <div class="col-8">
        <div class="system-block">
          <div class="mb-15">
            <p class="fw-bolder fsc-12 mb-15 text-dark"> 
              {{dataLang['vehicle_modal_files_text1']}}
              <span class="fw-normal text-uppercase">{{dataLang['vehicle_modal_files_text2']}}</span>

            </p>
            <div class="row gx-25">
              <div class="col-2" v-for="(docFile, index) in docsFiles" :key="docFile.id">
                <UploadFileWithPreview :file-preview="docFile.value" accept="image/*,.pdf" :max-weight="10000"
                  :max-x-size="1000" :max-y-size="750" :additionalParams="{ ...docFile }" type-of-form-data="vehicleDoc"
                  style="height: 109px" @clickOnImage="clickOnImage(docFile.value)" :error-message-max-weight="dataLang['error_message_max_file_size']
                    " classes="file-load--doc" @load-file="(params) => loadfileDoc(params)"
                  @remove-file="(params) => removefileDoc(params)" />
                <p class="text-muted fsc-11 mb-0 text-center">
                  {{ signsForDocs[index] }}
                </p>
              </div>
            </div>
          </div>
          <div class="mb-15">
            <p class="fw-bolder fsc-12 mb-15 text-dark">
              {{ dataLang['vehicle_modal_files_text3'] }} <br/>
            <span class="fw-normal">{{ dataLang['vehicle_modal_files_text4'] }}</span>
            </p>
            <div class="row gx-10 gy-15">
              <div style="flex: 135px 1 1" class="" v-for="(galleryFile, index) of galleryFiles"
                :key="galleryFile.position">
                <UploadFileWithPreview :file-preview="galleryFile.image?.vehicle_gallery__file" accept="image/*"
                  :max-weight="100000" :max-x-size="1000" :max-y-size="750" @clickOnImage="
                    clickOnImage(galleryFile.image?.vehicle_gallery__file)
                    " :additionalParams="{ ...galleryFile }" :error-message-max-weight="dataLang['error_message_max_file_size']
                    " style="height: 109px" :indexForPrint="galleryFile.position" :preview="galleryFile.icon"
                  classes="file-load--gallery" @load-file="(params) => loadfile(params)"
                  @remove-file="(params) => removefile(params)" />
                <p class="text-muted fsc-11 mb-0 text-center">
                  {{ dataLang[galleryFile.placeholder] }}
                </p>
              </div>
            </div>
          </div>
          <div class="fsc-14 fw-medium text-dark rounded-5" style="height: 44px" :class="calcClassForExeption">
            <div v-if="
              !dataForModal.vehicles__moderation_status_id ||
              dataForModal.vehicles__moderation_status_id == 1
            " @click="changeStatusVehicle"
              class="cursor-pointer text-center d-flex justify-content-center align-items-center h-100">
              <span v-html="dataLang['vehicle_modal_settings_text34']"></span>
            </div>

            <div class="cursor-pointer text-center d-flex justify-content-center align-items-center h-100"
              v-if="statusVehicle.vehicles__moderation_status_id == 2"
              v-html="dataLang['vehicle_modal_settings_text36']"></div>
            <div class="cursor-pointer text-center d-flex justify-content-center align-items-center h-100 fsc-11 px-10"
              v-if="statusVehicle.vehicles__moderation_status_id == 3"
              v-html="dataLang['vehicle_modal_settings_text37']"></div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="d-flex flex-column" style="gap: 30px; height: 100%;">
        <div class="system-block d-flex flex-column flex-grow-1" style="justify-content: flex-end;">
          <p class=" mb-15 text-dark text-center text-uppercase" style="font-size: 17px; line-height: 23px;">
            {{dataLang['interval_events_for_object_text104']}}
          </p>
          <div class="base-button base-button--action flex-grow-1 flex-column fsc-14 mb-15 text-white hover-underline-text" style="background: #00C8B3 !important; gap: 0px !important; max-height: 65px;" @click="getFileLoader">
            <span class="text-uppercase">Самостоятельно</span>
            <span class="">по этой инструкции</span>
          </div>
          <p class=" mb-15 text-dark text-center text-uppercase" style="font-size: 17px; line-height: 23px;">
            или
          </p>
          <div
            class="fsc-14 cursor-pointer base-button--action text-center text-white px-10 flex-grow-0 wp-100"
            style=" background-color: #023F8F; padding-block: 22.5px; text-transform: uppercase; border-radius: 5px; height: 65px;"
            @click="$modal.show('orderSendModal', { productId: 22, productName: 'Фотосъемка объекта', objectId: currentOpenedId })">
            Заказать фотосъемку
          </div>
          
        </div>


        <div class="system-block d-flex flex-column flex-grow-1" style="justify-content: flex-end;">
          <p class=" mb-15 text-dark text-center text-uppercase" style="font-size: 17px; line-height: 23px;">
            Сделайте качественное <br/>
видео про объект
          </p>
          <div class="base-button base-button--action flex-grow-1 flex-column fsc-14 mb-15 text-white hover-underline-text" style="background: #00C8B3 !important; gap: 0px !important; max-height: 65px;" @click="getFileLoaderVideo">
            <span class="text-uppercase">Самостоятельно</span>
            <span class="">по этой инструкции</span>
          </div>
          <p class=" mb-15 text-dark text-center text-uppercase" style="font-size: 17px; line-height: 23px;">
            или
          </p>
          <div
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0 wp-100"
            style=" background-color: #023F8F; padding-block: 22.5px; text-transform: uppercase; border-radius: 5px; height: 65px;"
            @click="$modal.show('orderSendModal', { productId: 23, productName: 'Видеосъемка объекта', objectId: currentOpenedId })">
            Заказать съемку ролика
          </div>
          
        </div>
        </div>
      </div>
    </div>

    <div class="row gx-15" v-if="!loadingState">
      <div class="col-8">
        <BaseInputNew placeholder="" :width="'590'" @input="updateValue" class="mb-0"
            input-name="vehicles__docs_youtube_link" :value="dataForModal?.vehicles__docs_youtube_link" signClass="text-muted" name-sign="Вставьте ссылку на Rutube Shorts (9:16)" />
      </div>
      <div class="col-4">
        <p class="fw-bolder fsc-14 text-dark mb-0 text-center d-flex align-items-center justify-content-center" style="line-height: 18px; height: 26px">
            {{ dataLang['vehicle_modal_files_text25'] }}
          </p>
      </div>
    </div>

    
    <AddNewPhotoBid :optionalParams="{ id: currentOpenedId }"></AddNewPhotoBid>
    <AddNewVideoBid :optionalParams="{ id: currentOpenedId }"></AddNewVideoBid>
    <gallery v-if="loadGallery && !loadingState" :images="images" :index="index" @close="index = null"></gallery>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import ObjectsService from '@/api/ObjectsService'
import UploadFileWithPreview from '@/components/UploadFileWithPreview.vue'
import StorageFileService from '@/api/StorageFileService'
import AddNewPhotoBid from '@/components/vehicles-page-single-modal-inner/AddNewPhotoBid.vue'
import AddNewVideoBid from '@/components/vehicles-page-single-modal-inner/AddNewVideoBid.vue'
import EventBus from '@/event-bus.js'
import VueGallery from 'vue-gallery'
import TransportVehiclesService from '@/api/TransportVehiclesService'
import GeneralService from '@/api/GeneralService'
//   import SingleModal from '@/components/SingleModal.vue'
export default {
  components: {
    UploadFileWithPreview,
    AddNewPhotoBid,
    AddNewVideoBid,
    gallery: VueGallery
  },
  props: {
    modeOpenModal: {
      type: String,
      default: 'create'
    },

    currentOpenedId: {
      type: Number
    }
  },
  data() {
    return {
      loadingState: true,
      docsFiles: [],
      galleryFiles: {},
      docsFilesForSend: {},
      galleryFilesForSend: [],
      updatedValues: {},
      ytLink: '',
      dataForModal: {},
      images: [],
      index: null,
      loadGallery: false,
      localIndexed: 0,
      statusVehicle: ''
    }
  },
  methods: {
    getFileLoader() {
      GeneralService.get('/objects/file1')
        .then((data) => {
          window.open(data.data, '_blank')
        })
        .catch(() => { })
    },
    getFileLoaderVideo() {
      GeneralService.get('/objects/file2')
        .then((data) => {
          window.open(data.data, '_blank')
        })
        .catch(() => { })
    },

    
    changeStatusVehicle() {

      this.$emit('loadingModal', true)
      TransportVehiclesService.update(this.currentOpenedId, {
        vehicles__moderation_status_id: 2
      })
        .then((data) => {
          this.$toast.success(data.data.message)
          this.dataForModal.vehicles__moderation_status_id = 2
          EventBus.$emit('contentLoaded')
          EventBus.$emit('updateContentData')
          this.$emit('loadingModal', false)
        })
        .catch((err) => {

          this.$emit('loadingModal', false)
          this.$toast.error(err.response.data.message, { duration: 5000 })
        })
    },
    clickOnImage(index) {


      this.index = this.images.findIndex((x) => x == index)
    },
    loadfileDoc(params) {
      this.$emit('loadingModal', true)
      this.loadingState = true

      params.fileInFormData.append('type', 'object_document')
      StorageFileService.upload(params.fileInFormData)
        .then((data) => {

          this.$toast.success(data.data.message)
          this.docsFilesForSend[params.key] = data.data.data.id
          let indexDocs = this.docsFiles.findIndex((x) => x.key == params.key)

          this.docsFiles[indexDocs].value = data.data.data.id
          // this.images.splice(params.index, 0, data.data.data.url);
          ObjectsService.update(this.currentOpenedId, {
            ...this.docsFilesForSend
          })
            .then((data) => {
              this.images.splice(params.index, 0, data.data.data.id)

              this.$toast.success(data.data.message)
              this.$emit('loadingModal', false)
              this.loadingState = false
              this.forceReload()
            })
            .catch((error) => {
              this.$toast.error(error.response.data.message, { duration: 5000 })
            })
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message, { duration: 5000 })
          this.$emit('loadingModal', false)
        })
    },
    removefileDoc(params) {

      this.$emit('loadingModal', true)
      this.docsFilesForSend[params.key] = null
      this.loadingState = true
      ObjectsService.delete('docs', this.currentOpenedId, params.key)
        .then((data) => {
          delete this.images[this.images.findIndex((x) => x == params.value)]
          this.$toast.success(data.data.message)
          this.$emit('loadingModal', false)
          this.loadingState = false
          this.forceReload()
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, { duration: 5000 })
        })

      //     delete(url, parentId, ids) {
      //
      //   return http.delete(this.basePathApiService + `/${parentId}/${url}/${ids}`)
      // }
    },
    loadfile(params) {

      this.$emit('loadingModal', true)
      this.loadingState = true
      params.fileInFormData.append('type', 'object_gallery')
      StorageFileService.upload(params.fileInFormData)
        .then((data) => {

          // this.galleryFiles[params.position].image = {
          //   vehicle_gallery__file: data.data.data.url,
          // }
          this.images.push(data.data.data.id)
          Promise.all([
            ObjectsService.update(this.currentOpenedId, {
              gallery: [
                {
                  vehicle_gallery__file: data.data.data.id,
                  vehicle_gallery__position: params.position
                }
              ]
            })
              .then((data) => {
                this.$toast.success(data.data.message)
                ObjectsService.getAll({
                  url: `/${this.currentOpenedId}/images`
                }).then((data) => {
                  this.galleryFiles = data.data.data.rows
                })
              })
              .catch((error) => {
                this.loadingState = false
                this.$emit('loadingModal', false)
                this.$toast.error(error.response.data.message, { duration: 5000 })
              })
          ]).then(() => {
            this.$emit('loadingModal', false)
            this.loadingState = false
            this.forceReload()
          })
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message, { duration: 5000 })
          this.$emit('loadingModal', false)
        })
    },
    removefile(params) {

      this.$emit('loadingModal', true)
      this.loadingState = true
      ObjectsService.delete(
        'images',
        this.currentOpenedId,
        params.image.vehicle_gallery__id
      )
        .then((data) => {
          delete this.images[
            this.images.findIndex(
              (x) => x == params.image.vehicle_gallery__file
            )
          ]
          this.$toast.success(data.data.message)
          this.$emit('loadingModal', false)
          this.loadingState = false
          this.forceReload()
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, { duration: 5000 })
        })
    },

    forceReload() {
      this.$emit('forceReload')
    },
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {

      if (Object.keys(this.updatedValues).length) {
        ObjectsService.update(this.currentOpenedId, {
          ...(this.updatedValues.vehicles__docs_youtube_link && {
            vehicles__docs_youtube_link:
              this.updatedValues.vehicles__docs_youtube_link
          })
        })
          .then((data) => {
            this.$toast.success(data.data.message)
            EventBus.$emit('contentLoaded')
            EventBus.$emit('updateContentData')
            callback(true, nameTab, oldTab, newTab, flagIsClose)
          })
          .catch((error) => {
            this.$toast.error(error.response.data.message, { duration: 5000 })
          })
      } else {
        callback(true, '', oldTab, newTab, flagIsClose)
      }
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value
    },
    getAllData() {
      Promise.all([
        ObjectsService.getAll({
          url: `/${this.currentOpenedId}?fields=vehicles__ygsf_city_no_driver,vehicles__docs_youtube_link,
        vehicles__moderation_status_id,
vehicles__ygsf_city_no_driver_min_days,
vehicles__ygsf_city_with_driver,
vehicles__ygsf_city_with_driver_min_hour,
vehicles__ygsf_city_buyout,
vehicles__ygsf_city_buyout_12,
vehicles__ygsf_city_buyout_24,
vehicles__ygsf_city_buyout_36,
vehicles__ygs_world,
vehicles__ygs_world_buyout,
vehicles__ygs_world_min_days,
vehicles__ygf_world,
vehicles__ygf_world_min_days,
vehicles__ygt_world,
vehicles__local_buyout_12,
vehicles__local_buyout_24,
vehicles__local_buyout_36,
vehicles__local_driver,
vehicles__local_driver_add_hour,
vehicles__local_nodriver_pledge,
vehicles__local_nodriver_min_days,
vehicles__local_driver_km_in_hour,
vehicles__local_driver_min_hours,
vehicles__local_nodriver, vehicles__local_buyout`
        })
          .then((data) => {

            this.dataForModal = data.data.data.rows[0]
            this.statusVehicle = this.dataForModal
          })
          .catch((err) => {

          }),
        ObjectsService.getAll({
          url: `/${this.currentOpenedId}?fields=vehicles__docs_file_1,vehicles__docs_file_2,vehicles__docs_file_3,vehicles__docs_file_4,vehicles__docs_file_5,vehicles__docs_file_6`
        })
          .then((data) => {
            let fetchedDocFiles = data.data.data.rows[0]
            for (const key in fetchedDocFiles) {
              this.docsFiles.push({
                key: key,
                id: key.split('__').at(-1),
                value: fetchedDocFiles[key],
                index: this.localIndexed
              })
              //
              // this.images.push(!!fetchedDocFiles[key] ? fetchedDocFiles[key] : '')
              if (
                !!fetchedDocFiles[key] &&
                fetchedDocFiles[key].split('.').at(-1) !== 'pdf'
              ) {
                this.images.push(fetchedDocFiles[key])
              }
            }
            // Object.keys(fetchedDocFiles).forEach((elem, index) => {
            //   if (elem.split('.').at(-1) !== 'pdf') {
            //     this.images.push(elem)
            //
            //   }
            // })

          })
          .catch((err) => { }),

        ObjectsService.getAll({
          url: `/${this.currentOpenedId}/images`
        }).then((data) => {
          this.galleryFiles = data.data.data.rows
          let iteratedFiles = []
          Object.values(data.data.data.rows).forEach((element) => {
            if (element.image.vehicle_gallery__file) {
              this.images.push(element.image.vehicle_gallery__file)
            }
          })

        }),

        ObjectsService.getAll({
          url: `/${this.currentOpenedId}?fields=vehicles__docs_youtube_link`
        }).then((data) => {

          this.ytLink = data.data.data.rows[0].vehicles__docs_youtube_link
        })

        // /objects/{id}?fields=vehicles__docs_youtube_link
      ]).then(() => {

        this.$emit('loadingModal', false)
        this.loadingState = false
        this.loadGallery = true
      })
    },
    ...mapActions('transportVehiclesModule', ['getHealth', 'getTitle'])
  },

  created() {
    this.$emit('loadingModal', true)
    this.getHealth(this.currentOpenedId)
    this.getTitle(this.currentOpenedId)

    this.getAllData()
  },
  computed: {
    calcClassForExeption() {
      if (
        !this.dataForModal.vehicles__moderation_status_id ||
        this.dataForModal.vehicles__moderation_status_id == 1
      ) {
        return ['cell-status-danger', 'text-white']
      } else if (this.dataForModal.vehicles__moderation_status_id == 2) {
        return 'cell-status-warning'
      } else if (this.dataForModal.vehicles__moderation_status_id == 3) {
        return ['bg-greensetting', 'text-white']
      }
    },
    signsForDocs() {
      return [
        this.dataLang['vehicle_modal_files_text30'],
        this.dataLang['vehicle_modal_files_text31'],
        this.dataLang['vehicle_modal_files_text32'],
        this.dataLang['vehicle_modal_files_text33'],
        this.dataLang['vehicle_modal_files_text34'],
        this.dataLang['vehicle_modal_files_text35']
      ]
    },
    ...mapState('translationModule', ['dataLang']),
    ...mapGetters('transportVehiclesModule', ['numPages'])
  }
}
</script>

<style scoped>
.bg-greensetting {
  background-color: rgba(35, 177, 77, 1);
}

.hover-underline-text:hover,
.hover-underline-text:hover * {
  text-decoration: underline;
}
</style>
